<template lang="pug">
.send-message-read-members-modal
  b-modal(v-model="_value" size="xl" no-close-on-backdrop no-close-on-esc hide-footer)
    .send-message-read-members-modal-table-component
      // テーブル
      b-table(
        :items="items"
        :fields="fields"
        :filter="filter"
        :filter-included-fields="filterFields"
        sticky-header
        no-border-collapse
        table-class="basic-table"
        show-empty
        :filter-function="filterTable"
      )
        // レコード無し
        template(#empty)
          .empty-message
            span 情報がありません
        // フィルター後レコード無し
        template(#emptyfiltered)
          .empty-message
            span 情報がありません
      
    .table-options.d-flex.flex-row.justify-content-end.align-items-center
      // フィルタリング
      span.table-option-text 施設関係者グループ:
      .filter.mr-0
        b-form-select(
          id="filter-input"
          v-model="filter"
          :options="filterOptions"
          size="md"
        )
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { OtherUserGroupSendMessageReadMemberModel } from "@/commons/services/OtherUserGroupSendMessageReadMembers";

/**
 * 施設関係者グループメンバー詳細表示モーダル
 */
@Component
export default class SafetyConfirmOtherUsersModal extends Vue {
  /** 表示可否 */
  @Prop()
  value!: boolean;

  /** 表示対象の家族 */
  @Prop()
  items!: Array<SafetyConfirmOtherUserModelTableItem>;
  /** フィルター選択項目 */
  @Prop()
  filterOptions!: Array<{ value: string; text: string }>;

  /** 列名配列 */
  fields: Array<SafetyConfirmOtherUsersModalTableField> = [
    { key: "groupTypeName", label: "種類", sortable: false, sortDirection: "desc", class: "group-type-name" },
    { key: "groupName", label: "グループ名", sortable: false, sortDirection: "desc", class: "group-name" },
    { key: "groupMemberName", label: "ユーザー名", sortable: false, sortDirection: "desc", class: "group-member-name" },
    { key: "groupMemberTel", label: "電話番号", sortable: false, sortDirection: "desc", class: "group-member-tel" },
    { key: "groupMemberOrganization", label: "所属", sortable: false, sortDirection: "desc", class: "group-member-organization" }
  ];
  /** フィルタリング条件 */
  filter: any = "";
  /** フィルタリング対象カラム名 */
  filterFields: string[] = ["groupId"];

  /**
   * ### フィルタリング
   */
  public filterTable(row: SafetyConfirmOtherUserModelTableItem): boolean {
    if (row.groupId == this.filter) {
      return true;
    } else {
      return false;
    }
  }

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }
}

export interface SafetyConfirmOtherUserModelTableItem extends OtherUserGroupSendMessageReadMemberModel {
  /** グループ名 */
  groupTypeName: string;
}

export interface SafetyConfirmOtherUsersModalTableField {
  key: string;
  label: string;
  sortable: boolean;
  sortDirection: string;
  class?: string;
}
</script>
